import type { EsgSfdrTaxonomy } from '../esg/esg.types'
import type { IndicatorRiskLevelEsgPai } from '../indicators/risk-level.types'

export const INVESTOR_PROFILE_ACCESS_STATUSES = {
  MUST_UPDATE: 'must_update',
  CAN_UPDATE: 'can_update',
  DISABLED: 'disabled',
} as const

export type InvestorProfileAccessStatus = ValueOf<
  typeof INVESTOR_PROFILE_ACCESS_STATUSES
>

export const InvestorProfileLabels = {
  SECURE: 'secure',
  CAUTIOUS: 'cautious',
  BALANCED: 'balanced',
  DYNAMIC: 'dynamic',
  AGGRESSIVE: 'aggressive',
  NONE: 'none',
} as const

export type InvestorProfileLabel = ValueOf<typeof InvestorProfileLabels>

export type InvestorProfileAccess = {
  status: InvestorProfileAccessStatus
  piStatus: InvestorProfileAccessStatus
  qceStatus: InvestorProfileAccessStatus
  esgStatus: InvestorProfileAccessStatus
}

export type InvestorProfile = {
  label: string
  updatedAt?: string
  score?: number
  piScore?: number
  piLabel?: string
  qceCode?: string
  qceLabel?: string
  esgScore?: number
  esgLabel?: string
  mustUpdateQualification?: boolean
  access: InvestorProfileAccess
  riskInterval: {
    min: number
    max: number
    target: number
  }
  esg: {
    pai?: IndicatorRiskLevelEsgPai
    sfdr?: EsgSfdrTaxonomy
    taxonomy?: EsgSfdrTaxonomy
  }
}
